import { getQaSelector } from '../../../../utils/common'
import { Skeleton } from '../../../Skeleton'

import {
  GRETA_AI_CHAT_CHAT_LIST_SKELETON_SECTIONS,
  QA_NAME_GRETA_AI_CHAT_CHAT_LIST_SKELETON,
} from './GretaAIChatChatListSkeleton.constants'

import * as styles from './GretaAIChatChatListSkeleton.module.css'

function GretaAIChatChatListSkeleton() {
  const qaProps = getQaSelector({
    value: QA_NAME_GRETA_AI_CHAT_CHAT_LIST_SKELETON,
  })

  return (
    <div {...qaProps} aria-hidden className={styles.skeleton}>
      {GRETA_AI_CHAT_CHAT_LIST_SKELETON_SECTIONS.map(
        (section, sectionIndex) => (
          <div className={styles.section} key={sectionIndex}>
            <Skeleton
              className={styles.sectionTitle}
              style={{ width: section.titleWidth }}
            />

            <div className={styles.items}>
              {section.itemWidths.map((width, itemIndex) => (
                <div className={styles.item} key={itemIndex}>
                  <Skeleton className={styles.itemTitle} style={{ width }} />
                  <Skeleton className={styles.itemSubtitle} />
                </div>
              ))}
            </div>
          </div>
        )
      )}
    </div>
  )
}

export default GretaAIChatChatListSkeleton
